module.exports = __webpack_public_path__ + "img/un.55afd625.svg";